@let isMobileVal = shellState.isMobile();
@let minimized = navState.minimized();
@let forceMaximized = navState.forceMaximized();

<div class="sidebar-content">
  <div class="sidebar-switcher-wrapper">
    <tlc-app-switcher-next
      [walkthroughId]="appSwitcherWalkthroughId()"
      (dropdownOpenChange)="onDropdownOpenChange($event)"
    />
  </div>

  <div class="sidebar-content-wrapper">
    <div class="sidebar-nav-area">
      <div class="sidebar-navigation-wrapper" cdkScrollable>
        <tlc-navigation [walkthroughId]="navigationWalkthroughId()" />
      </div>

      @if (tellentAssistantFlag()) {
        <div class="sidebar-assistant-gradient"></div>
        <div class="sidebar-assistant-wrapper">
          <tellent-assistant
            [collapsed]="minimized"
            (triggerLeave)="!shellState.isMobile() ? onAssistantTriggerLeave($event) : null"
          />
        </div>
      }
    </div>

    @if (!isMobileVal) {
      <tlc-main-navigation-toggle
        (click)="toggleSidebarMinimized(!forceMaximized ? false : !minimized)"
        [forceMaximized]="forceMaximized"
        [minimized]="minimized"
      />
    }
  </div>
</div>

@if (isMobileVal) {
  <div class="sidebar-backdrop" (click)="toggleSidebarMinimized(true)"></div>
}
